import { render, staticRenderFns } from "./WebPortal.vue?vue&type=template&id=83d773cc&scoped=true&"
import script from "./WebPortal.vue?vue&type=script&lang=js&"
export * from "./WebPortal.vue?vue&type=script&lang=js&"
import style0 from "./WebPortal.vue?vue&type=style&index=0&id=83d773cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d773cc",
  null
  
)

export default component.exports